import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/mh200/h5/');

export default function MhGh5C({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('waveportableairconditioner');

    return (
        <div className={`${css.mhGh5} mhGh5 mhGh5C`}>
            <div className="ms-title1">{t('mh200.mhG_ms7')}</div>
            <div className="ms-title2">{t('mh200.mhG_ms8')}</div>
            <div className="img-box">
                <EFPic name={["product07_3.webp", "product07_3.jpg"]} className="fullImgs" alt={t('mh200.mhG_ms7')} />
            </div>
            <div className="ms-desc">
                {t.rich('mh200.mhG_ms9', {
                    line1: (text: any) => <span className="color-ms3">{text}</span>,
                })}
            </div>
        </div>
    );
}
